import dayjs from 'dayjs';
import 'dayjs/locale/de';

dayjs.locale('de');

/**
 * Formats termin date/time display
 * @returns "Montag, 5. Februar · 14:00 – 16:00" or "Montag, 5. Februar"
 */
export function formatTerminDateTime(
  datum: string,
  beginn?: string | null,
  ende?: string | null,
): string {
  const dateDayjs = dayjs(datum);
  const datePart = dateDayjs.format('dddd, D. MMMM YYYY');

  if (!beginn) {
    return datePart;
  }

  const startTime = dayjs(beginn).format('HH:mm');
  const endTime = ende ? ` – ${dayjs(ende).format('HH:mm')}` : '';

  return `${datePart} · ${startTime}${endTime}`;
}

/**
 * Formats time range
 * @returns "14:00 – 16:00"
 */
export function formatTimeRange(
  beginn?: string | null,
  ende?: string | null,
): string {
  if (beginn && ende) {
    const startTime = dayjs(beginn).format('HH:mm');
    const endTime = dayjs(ende).format('HH:mm');
    return `${startTime} – ${endTime}`;
  }
  if (beginn) {
    const startTime = dayjs(beginn).format('HH:mm');
    return `${startTime} – ?`;
  }
  if (ende) {
    const endTime = dayjs(ende).format('HH:mm');
    return `? – ${endTime}`;
  }
  return '';
}

/**
 * Formats a date with an optional time range
 * @returns "Mi., 6. Mai 2026, 14:00 – 16:00"
 */
export function formatDateTimeRange(
  datum: string,
  beginn?: string | null,
  ende?: string | null,
): string {
  const datePart = dayjs(datum).locale('de').format('dd., D. MMMM YYYY');
  const parts = [datePart, formatTimeRange(beginn, ende)];
  return parts.filter(Boolean).join(', ');
}
